import React from 'react';
import shivamPhoto from '../../assets/shivamPhoto.png';
import { MdOutlineKeyboardArrowRight } from "react-icons/md";
import { Link } from 'react-scroll';


const Home = () => {
    return (
        <>
            <div name="home" className=" w-full bg-gradient-to-b from-black via-black to-gray-800 pt-8" >

                <div className="max-w-screen-lg mx-auto flex flex-col items-center justify-center h-full px-4 md:flex-row ">

                    <div className=" flex flex-col justify-center h-full ">

                        <h2 className='text-4xl md:text-7xl font-bold text-white' >I'm a Frontend Developer </h2>
                        <p className='text-gray-200 text-2xl  py-4 max-w-md'>
                            Hi, welcome to my portfolio.
                        </p>
                        <div className="">
                            <Link to='Projects' smooth duration={500} className="group flex text-white w-fit px-6 py-3 my-2 items-center rounded-md bg-gradient-to-r from-cyan-500 to-blue-500 cursor-pointer " >
                                Projects
                                <span className="group-hover:rotate-90 duration-300" >
                                    <MdOutlineKeyboardArrowRight size={25} className='ml-1' />
                                </span>
                            </Link >
                        </div>

                    </div>

                    <div className="">
                        <img
                            src={shivamPhoto}
                            alt="shivam_image"
                            className="rounded-2xl mx-auto w-2/3 md:w-full" />
                    </div>

                </div>
            </div>
        </>
    )
}

export default Home;